import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'GENERAL',
    icon: 'fas fa-ellipsis-h',
    class: 'nav-small-cap',
    extralink: true,
    submenu: [],
  },
  {
    path: '/dashboard',
    title: 'Dashboard',
    icon: 'fas fa-tachometer-alt',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/estimate/estimate-list',
    title: 'Estimates',
    icon: 'fas fa-clipboard-check',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/doc/doc-list',
    title: 'Documents',
    icon: 'fas fa-copy',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/message/message-list',
    title: 'Messages',
    icon: 'fas fa-envelope',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '',
    title: 'Administration',
    icon: 'fas fa-ellipsis-h',
    class: 'nav-small-cap',
    extralink: true,
    submenu: [],
  },
  // {
  //   path: '/profile/my-profile',
  //   title: 'My Profile',
  //   icon: 'fas fa-user',
  //   class: '',
  //   extralink: false,
  //   submenu: [],
  // },
  {
    path: '/profile/password-reset',
    title: 'Password Reset',
    icon: 'fas fa-sync-alt',
    class: '',
    extralink: false,
    submenu: [],
  },
  {
    path: '/logout',
    title: 'Logout',
    icon: 'fas fa-power-off',
    class: '',
    extralink: false,
    submenu: [],
    function: 'logout'
  }
];
